module.exports = __webpack_public_path__ + "assets/images/M-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/M-route-sheet.png
// module id = 1417
// module chunks = 1